import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Container,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import axios from "axios";
import { imgUrl, url } from "src/Helpers/utils/Constant";
import GlobalLoader from "src/components/SuspenseLoader/GlobalLoader";
import moment from "moment";
import { getStatusLabel } from "src/Utils/Combined";
import EditIcon from "@mui/icons-material/Edit";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import UpdateTraineeDuplicateId from "./UpdateTraineeDuplicateId";
import { CommonTypoGraphy } from "src/components/pdfAndImageView/CommonTypoGraphy";
import PdfAndImageView from "src/components/pdfAndImageView/PdfAndImageView";

const SingleTraineeDuplicateId = () => {
  const { id } = useParams();
  const [singleDuplicateIdCard, setSingleDuplicateIdCard] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [imageViewOpen, SetImageViewOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>("");

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        const { data } = await axios.get(
          `${url}/api/training/services/trainee/trainee-duplicateId/${id}`
        );

        if (data.success) {
          setSingleDuplicateIdCard(data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [id]);
  return (
    <>
      <Helmet>
        <title>Atab - Single duplicate id card</title>
      </Helmet>

      <Container sx={{ mt: 4 }} maxWidth="xl">
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        >
          {loading ? (
            <GlobalLoader />
          ) : (
            <Container>
              <Card>
                <CardHeader
                  title={`Duplicate id card #${singleDuplicateIdCard.trainee_duplicate_ID_id}`}
                  action={
                    <>
                      {singleDuplicateIdCard.status === "pending" && (
                        <Button
                          size="small"
                          onClick={() => setOpen(true)}
                          variant="contained"
                          startIcon={<EditIcon />}
                        >
                          Update
                        </Button>
                      )}
                    </>
                  }
                />

                <Grid
                  container
                  p={2}
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                >
                  <Grid item xs={12} sm={4} md={3}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      display="inline"
                      sx={{ pr: 1 }}
                      gutterBottom
                    >
                      Status:
                    </Typography>
                    {getStatusLabel(singleDuplicateIdCard.status)}
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      display="inline"
                      sx={{ pr: 1 }}
                      gutterBottom
                    >
                      Created at:
                    </Typography>
                    {moment(singleDuplicateIdCard.created_at).format(
                      "MMM Do YYYY"
                    )}
                  </Grid>

                  <Grid item xs={12} sm={12} md={6}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      display="inline"
                      sx={{ pr: 1 }}
                      gutterBottom
                    >
                      Details :
                    </Typography>
                    {singleDuplicateIdCard.details}
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Box display={"flex"} alignItems={"start"}>
                      <CommonTypoGraphy
                        name="View gd file"
                        onClick={() => {
                          SetImageViewOpen(true);
                          setImageFile(singleDuplicateIdCard.gd_copy_file);
                        }}
                      />
                    </Box>
                  </Grid>

                  {singleDuplicateIdCard.note && (
                    <Grid item xs={12} sm={12} md={6}>
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        color="text.primary"
                        display="inline"
                        sx={{ pr: 1 }}
                        gutterBottom
                      >
                        Note :
                      </Typography>
                      {singleDuplicateIdCard.note}
                    </Grid>
                  )}
                </Grid>
              </Card>
            </Container>
          )}
        </Grid>
      </Container>
      <ModalsWrapper
        setShowModal={setOpen}
        showModal={open}
        modalData={{
          title: "Update single duplicate id card ",
        }}
      >
        <UpdateTraineeDuplicateId
          singleDuplicateIdCard={singleDuplicateIdCard}
          handelClose={() => setOpen(false)}
          id={singleDuplicateIdCard.trainee_duplicate_ID_id}
          setSingleDuplicateIdCard={setSingleDuplicateIdCard}
        />
      </ModalsWrapper>
      <PdfAndImageView
        setOpen={SetImageViewOpen}
        open={imageViewOpen}
        file={imageFile}
      />
    </>
  );
};

export default SingleTraineeDuplicateId;
